<template>
  <div class="page page-contact">
    <div class="pagewrap">
      <div class="contact">
        <p class="fade-me">I'm Daniel, and I love making websites.</p>
        <p class="fade-me">Want to build something together?</p>
        <p class="fade-me">Get @ me:</p>
        <div class="link-section-wrap">
          <div class="icon-links">
            <a class="fade-me" href="https://github.com/tealicious" target="_blank" title="Daniel Carter on GitHub">
              <github />
            </a>
            <a
              class="fade-me"
              href="https://www.linkedin.com/in/daniel-carter-a49b9b41/"
              target="_blank"
              title="Daniel Carter on LinkedIn"
            >
              <linkedin />
            </a>
          </div>
          <div class="text-links">
            <a class="cred fade-me" href="https://tealicious.github.io/" target="_blank">resumé</a>
            <a class="email fade-me" href="mailto:carterdanielr@gmail.com" target="_blank">carterdanielr@gmail.com</a>
            <!-- <a class="phone fade-me" href="tel:513-519-7464">513.519.7464</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Github from "@/components/svg/Github.vue";
import Linkedin from "@/components/svg/Linkedin.vue";
const increment = 0.1;
export default {
  components: { Github, Linkedin },
  mounted() {
    let fadeIns = this.$el.querySelectorAll(".fade-me");
    let animationDelay = 0;
    for (let i = 0; i < fadeIns.length; i++) {
      fadeIns[i].style.animationDelay = animationDelay + "s";
      animationDelay += increment;
    }
  },
};
</script>
<style lang="scss" scoped>
.text-links {
  display: flex;
  flex-direction: column;
  a {
    align-self: flex-start;
  }
}
</style>